// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   DonateForm — /donate body: gift widget + trust strip
   ============================================================ */

.dnform {
  background: var(--c-cream);
  border-top: 1px solid var(--line);
}

/* ── Two-column layout ── */
.dnform__inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(3rem, 7vw, 8rem);
  align-items: start;
  padding-block: clamp(3rem, 6vw, 5.5rem);
}

/* ══════════════════════════════════════════════════════════════
   LEFT — headline + copy + badge
══════════════════════════════════════════════════════════════ */

.dnform__left {
  display: flex;
  flex-direction: column;
  gap: clamp(0.85rem, 1.5vw, 1.25rem);
}

.dnform__eyebrow {
  color: var(--accent) !important;
  letter-spacing: 0.24em;
}

.dnform__headline {
  font-size: clamp(2.4rem, 5.5vw, 4.8rem);
  color: var(--c-forest);
  line-height: 0.9;
  margin: 0;
}

.dnform__rule {
  display: block;
  width: clamp(2rem, 3.5vw, 3rem);
  height: 3px;
  background: var(--accent);
  margin-block: 0.2rem;
}

.dnform__sub {
  font-family: var(--font-body);
  font-size: clamp(0.88rem, 1.1vw, 1rem);
  color: var(--c-ink);
  line-height: 1.7;
  margin: 0;
  max-width: 26rem;
}

/* 501c3 badge box */
.dnform__badge {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 1rem 1.1rem;
  margin-top: 0.5rem;
  max-width: 26rem;
}

.dnform__badge-icon {
  flex-shrink: 0;
  width: 2.4rem;
  height: 2.4rem;
  color: var(--accent);
}
.dnform__badge-icon svg { width: 100%; height: 100%; }

.dnform__badge-text {
  font-family: var(--font-body);
  font-size: 0.8rem;
  color: var(--text-muted);
  line-height: 1.55;
  margin: 0;
}

/* ══════════════════════════════════════════════════════════════
   RIGHT — donation widget
══════════════════════════════════════════════════════════════ */

.dnform__widget {
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: clamp(1.5rem, 3vw, 2.5rem);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: var(--c-cream);
}

/* Frequency toggle */
.dnform__freq {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  overflow: hidden;
}

.dnform__freq-btn {
  background: transparent;
  border: none;
  padding: 0.75rem 1rem;
  font-family: var(--font-body);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--text-muted);
  cursor: pointer;
  transition: background var(--dur) var(--ease), color var(--dur) var(--ease);
}

.dnform__freq-btn--active {
  background: var(--accent);
  color: var(--on-accent);
}

/* Amount grid */
.dnform__amounts {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.55rem;
}

.dnform__amt-btn {
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  background: transparent;
  padding: 0.7rem 0.5rem;
  font-family: var(--font-body);
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--c-ink);
  cursor: pointer;
  text-align: center;
  transition: background var(--dur) var(--ease), border-color var(--dur) var(--ease), color var(--dur) var(--ease);
}

.dnform__amt-btn--active {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--on-accent);
}

.dnform__amt-btn:hover:not(.dnform__amt-btn--active) {
  border-color: var(--accent);
  color: var(--accent);
}

/* Custom amount input */
.dnform__amt-input {
  appearance: none;
  outline: none;
  font-size: 0.78rem;
  letter-spacing: 0.1em;
}
.dnform__amt-input::placeholder {
  font-size: 0.68rem;
  letter-spacing: 0.14em;
  color: rgba(27,27,27,0.35);
  font-weight: 700;
}
.dnform__amt-input::-webkit-outer-spin-button,
.dnform__amt-input::-webkit-inner-spin-button { -webkit-appearance: none; }

/* Dedicate checkbox */
.dnform__dedicate {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  cursor: pointer;
}

.dnform__checkbox {
  width: 1rem;
  height: 1rem;
  border: 1.5px solid var(--line);
  border-radius: 2px;
  cursor: pointer;
  accent-color: var(--accent);
  flex-shrink: 0;
}

.dnform__dedicate-label {
  font-family: var(--font-body);
  font-size: 0.78rem;
  color: var(--text-muted);
  line-height: 1.4;
}

/* Primary donate button */
.dnform__donate-btn {
  width: 100%;
  background: var(--accent);
  color: var(--on-accent);
  border: none;
  border-radius: 0;
  padding: 1rem;
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 0.72rem;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background var(--dur) var(--ease);
}
.dnform__donate-btn:hover { background: var(--accent-hover); }
.dnform__donate-btn:disabled { opacity: 0.4; cursor: not-allowed; }

/* OR divider */
.dnform__or {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-block: -0.1rem;
}
.dnform__or-line {
  flex: 1 1;
  height: 1px;
  background: var(--line);
}
.dnform__or-text {
  font-family: var(--font-body);
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  color: var(--text-muted);
}

/* Pay buttons */
.dnform__pay-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 0.85rem 1rem;
  border-radius: 2px;
  font-family: var(--font-body);
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  transition: opacity var(--dur) var(--ease);
}
.dnform__pay-btn:hover { opacity: 0.85; }

.dnform__pay-btn span {
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.08em;
}

.dnform__pay-btn--gpay {
  background: #fff;
  border: 1px solid var(--line);
  color: var(--c-ink);
}

.dnform__pay-btn--apay {
  background: #1a1a1a;
  border: none;
  color: #fff;
}

.dnform__gpay-logo,
.dnform__apay-logo {
  height: 1.1rem;
  width: auto;
}

/* Secure note */
.dnform__secure {
  font-family: var(--font-body);
  font-size: 0.68rem;
  color: var(--text-muted);
  text-align: center;
  margin: -0.25rem 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
}
.dnform__secure svg { font-size: 0.65rem; }

/* Success banner */
.dnform__success {
  padding: 1.5rem;
  text-align: center;
}
.dnform__success p {
  font-family: var(--font-serif);
  font-style: italic;
  font-size: 1.05rem;
  color: var(--c-forest);
  line-height: 1.6;
  margin: 0;
}

/* ══════════════════════════════════════════════════════════════
   YOU CAN TRUST US strip
══════════════════════════════════════════════════════════════ */

.dnform__trust {
  background: var(--c-cream);
  border-top: 1px solid var(--line);
  padding-block: clamp(2rem, 4vw, 3.5rem);
}

.dnform__trust-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(1rem, 2.5vw, 2.5rem);
  margin-bottom: clamp(1.75rem, 3vw, 2.75rem);
}

.dnform__trust-rule {
  display: block;
  flex: 1 1;
  max-width: clamp(3rem, 8vw, 8rem);
  height: 1px;
  background: var(--line);
}

.dnform__trust-eyebrow {
  /* u-eyebrow base */
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;
}

/* 4-column trust grid */
.dnform__trust-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
}

.dnform__trust-item {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  padding-inline: clamp(0.75rem, 2vw, 1.75rem);
  position: relative;
}

.dnform__trust-item:not(:last-child)::after {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 1px;
  background: var(--line);
}

.dnform__trust-icon {
  font-size: 1.25rem;
  color: var(--accent);
  flex-shrink: 0;
  margin-top: 2px;
  display: flex;
}

.dnform__trust-text {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.dnform__trust-label {
  font-family: var(--font-body);
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--c-ink);
  margin: 0;
}

.dnform__trust-desc {
  font-family: var(--font-body);
  font-size: clamp(0.72rem, 0.9vw, 0.82rem);
  color: var(--text-muted);
  line-height: 1.55;
  margin: 0;
}

/* Responsive */
@media (max-width: 991.98px) {
  .dnform__inner { grid-template-columns: 1fr; gap: 2.5rem; }
  .dnform__trust-grid { grid-template-columns: repeat(2, 1fr); gap: 1.5rem 0; }
  .dnform__trust-item:nth-child(2)::after,
  .dnform__trust-item:nth-child(4)::after { display: none; }
}

@media (max-width: 575.98px) {
  .dnform__amounts { grid-template-columns: repeat(3, 1fr); }
  .dnform__trust-grid { grid-template-columns: 1fr; }
  .dnform__trust-item::after { display: none; }
}

/* ═══════════════════════════════════════════════════════
   Stripe Payment Element + new fields
═══════════════════════════════════════════════════════ */

/* ── Checkout wrapper ── */
.dnform__checkout {
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* Summary bar above Payment Element */
.dnform__checkout-bar {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  background: rgba(184,92,56,0.06);
  border: 1px solid rgba(184,92,56,0.18);
  border-radius: 9px;
  padding: 0.85rem 1rem;
  margin-bottom: 1.25rem;
}
.dnform__checkout-label {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #9ca3af;
  margin: 0 0 0.2rem;
}
.dnform__checkout-amount {
  font-size: 1.4rem;
  font-weight: 800;
  color: #b85c38;
  margin: 0;
  line-height: 1;
}
.dnform__checkout-amount span {
  font-size: 0.8rem;
  font-weight: 600;
  opacity: 0.7;
  margin-left: 0.25rem;
}
.dnform__checkout-campaign {
  font-size: 0.82rem;
  font-weight: 700;
  color: #1b1b1b;
  margin: 0;
}

/* Payment Element container */
.dnform__payment-element-wrap {
  margin-bottom: 0;
}

/* Stripe error message */
.dnform__stripe-error {
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
  background: rgba(220,38,38,0.07);
  border: 1px solid rgba(220,38,38,0.22);
  border-radius: 7px;
  padding: 0.65rem 0.85rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: #dc2626;
  margin-top: 0.85rem;
}
.dnform__stripe-error span { font-size: 0.75rem; flex-shrink: 0; }

/* Stripe form wrapper */
.dnform__stripe-form { display: flex; flex-direction: column; }

/* Back link */
.dnform__back-link {
  background: none;
  border: none;
  font-size: 0.78rem;
  font-weight: 600;
  color: #9ca3af;
  cursor: pointer;
  text-align: center;
  margin-top: 0.75rem;
  padding: 0.25rem;
  transition: color 0.15s;
}
.dnform__back-link:hover { color: #6b6258; }
.dnform__back-link:disabled { opacity: 0.4; cursor: wait; }

/* ── Picker fields ── */
.dnform__field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin-bottom: 0.85rem;
}
.dnform__field-label { font-size: 0.8rem; font-weight: 700; color: #1b1b1b; }
.dnform__field-opt   { font-size: 0.72rem; font-weight: 400; color: #9ca3af; }
.dnform__field-req   { color: #b85c38; }
.dnform__field-hint  { font-size: 0.7rem; color: #9ca3af; margin: 0.15rem 0 0; }
.dnform__field-error { font-size: 0.75rem; color: #dc2626; font-weight: 600; margin: 0.15rem 0 0; }

.dnform__input {
  padding: 0.65rem 0.85rem;
  border: 1px solid #ddd5c8;
  border-radius: 7px;
  background: #fff;
  font-size: 0.88rem;
  color: #1b1b1b;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.dnform__input:focus {
  border-color: #b85c38;
  box-shadow: 0 0 0 3px rgba(184,92,56,0.1);
}
.dnform__input--error {
  border-color: #dc2626;
  box-shadow: 0 0 0 3px rgba(220,38,38,0.08);
}

.dnform__select-wrap { position: relative; }
.dnform__select {
  appearance: none;
  width: 100%;
  padding: 0.65rem 2rem 0.65rem 0.85rem;
  border: 1px solid #ddd5c8;
  border-radius: 7px;
  background: #fff;
  font-size: 0.88rem;
  color: #1b1b1b;
  outline: none;
  cursor: pointer;
  transition: border-color 0.15s;
}
.dnform__select:focus  { border-color: #b85c38; }
.dnform__select-chevron {
  position: absolute;
  right: 0.85rem;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #9ca3af;
  font-size: 0.75rem;
}

/* ── Methods strip (below CTA) ── */
.dnform__methods-strip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  font-size: 0.7rem;
  color: #9ca3af;
  margin-top: 0.75rem;
  font-weight: 500;
}

/* ── Accepted payment logos (left column) ── */
.dnform__accepted { margin-top: 1.75rem; }
.dnform__accepted-label {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #9ca3af;
  margin: 0 0 0.6rem;
}
.dnform__accepted-logos {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  align-items: center;
}
.dnform__pm-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  padding: 0 0.6rem;
  border-radius: 4px;
  background: #f4efe6;
  border: 1px solid #e8e3da;
}
.dnform__pm-chip svg { height: 14px; display: block; }
.dnform__pm-chip--visa  { background: #fff; }
.dnform__pm-chip--amex  { background: #2E77BC; }
.dnform__pm-chip--gpay  { background: #fff; }
.dnform__pm-chip--apay  { background: #000; }
.dnform__pm-chip--link  { background: #00D66B; padding: 0 0.75rem; }

/* ── Loading / disabled / success ── */
.dnform__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 220px;
}

.dnform__disabled {
  text-align: center;
  padding: 2.5rem 1rem;
}
.dnform__disabled-icon  { font-size: 2.5rem; margin-bottom: 0.85rem; }
.dnform__disabled-title { font-family: var(--font-serif); font-size: 1.4rem; color: #384638; margin: 0 0 0.75rem; }
.dnform__disabled-text  { font-size: 0.88rem; color: #6b6258; line-height: 1.6; margin: 0; }
.dnform__disabled-text a { color: #b85c38; }

.dnform__success-v2 { text-align: center; padding: 2rem 0.5rem; }
.dnform__success-icon-lg { font-size: 3rem; margin-bottom: 0.75rem; }
.dnform__success-title   { font-family: var(--font-serif); font-size: 1.6rem; color: #384638; margin: 0 0 0.35rem; }
.dnform__success-amt     { font-size: 1.75rem; font-weight: 800; color: #b85c38; margin: 0 0 0.85rem; }
.dnform__success-text    { font-size: 0.9rem; color: #1b1b1b; line-height: 1.6; margin: 0 0 0.5rem; }
.dnform__success-sub     { font-size: 0.8rem; color: #6b6258; line-height: 1.55; margin: 0; }

/* ── Spinner ── */
.dnform__spinner {
  display: inline-block;
  width: 0.9rem;
  height: 0.9rem;
  border: 2px solid rgba(255,255,255,0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: dnform-spin 0.65s linear infinite;
  vertical-align: middle;
}
.dnform__spinner--lg {
  width: 2rem;
  height: 2rem;
  border-color: rgba(184,92,56,0.2);
  border-top-color: #b85c38;
}
@keyframes dnform-spin { to { transform: rotate(360deg); } }
`, "",{"version":3,"sources":["webpack://./src/pages/DonateForm.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;;gEAEgE;;AAEhE;EACE,aAAa;EACb,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,oBAAoB;AACtB;AACA,0BAA0B,WAAW,EAAE,YAAY,EAAE;;AAErD;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA;;gEAEgE;;AAEhE;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gHAAgH;AAClH;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EAEE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;gDACgD,wBAAwB,EAAE;;AAE1E,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,6CAA6C;AAC/C;AACA,4BAA4B,+BAA+B,EAAE;AAC7D,+BAA+B,YAAY,EAAE,mBAAmB,EAAE;;AAElE,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,SAAO;EACP,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;AAC5C;AACA,yBAAyB,aAAa,EAAE;;AAExC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA,sBAAsB,kBAAkB,EAAE;;AAE1C,mBAAmB;AACnB;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;;AAEA;;gEAEgE;;AAEhE;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,SAAO;EACP,iCAAiC;EACjC,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,MAAM;AACR;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,yCAAyC;EACzC,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,iBAAiB,0BAA0B,EAAE,WAAW,EAAE;EAC1D,sBAAsB,qCAAqC,EAAE,aAAa,EAAE;EAC5E;4CAC0C,aAAa,EAAE;AAC3D;;AAEA;EACE,mBAAmB,qCAAqC,EAAE;EAC1D,sBAAsB,0BAA0B,EAAE;EAClD,6BAA6B,aAAa,EAAE;AAC9C;;AAEA;;yDAEyD;;AAEzD,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA,6BAA6B,kBAAkB,EAAE,cAAc,EAAE;;AAEjE,wBAAwB;AACxB,uBAAuB,aAAa,EAAE,sBAAsB,EAAE;;AAE9D,cAAc;AACd;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,2BAA2B,cAAc,EAAE;AAC3C,8BAA8B,YAAY,EAAE,YAAY,EAAE;;AAE1D,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;AACA,uBAAuB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC5E,uBAAuB,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC7E,uBAAuB,cAAc,EAAE;AACvC,uBAAuB,iBAAiB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC/E,uBAAuB,kBAAkB,EAAE,cAAc,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAElG;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,gDAAgD;AAClD;AACA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;AACA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA,uBAAuB,kBAAkB,EAAE;AAC3C;EACE,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;AACA,yBAAyB,qBAAqB,EAAE;AAChD;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C,oBAAoB,mBAAmB,EAAE;AACzC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA,uBAAuB,YAAY,EAAE,cAAc,EAAE;AACrD,0BAA0B,gBAAgB,EAAE;AAC5C,0BAA0B,mBAAmB,EAAE;AAC/C,0BAA0B,gBAAgB,EAAE;AAC5C,0BAA0B,gBAAgB,EAAE;AAC5C,0BAA0B,mBAAmB,EAAE,kBAAkB,EAAE;;AAEnE,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA,0BAA0B,iBAAiB,EAAE,sBAAsB,EAAE;AACrE,0BAA0B,8BAA8B,EAAE,iBAAiB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAClH,0BAA0B,kBAAkB,EAAE,cAAc,EAAE,gBAAgB,EAAE,SAAS,EAAE;AAC3F,2BAA2B,cAAc,EAAE;;AAE3C,sBAAsB,kBAAkB,EAAE,oBAAoB,EAAE;AAChE,2BAA2B,eAAe,EAAE,sBAAsB,EAAE;AACpE,2BAA2B,8BAA8B,EAAE,iBAAiB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACnH,2BAA2B,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACtG,2BAA2B,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACpG,2BAA2B,iBAAiB,EAAE,cAAc,EAAE,iBAAiB,EAAE,SAAS,EAAE;;AAE5F,kBAAkB;AAClB;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,wCAAwC;EACxC,sBAAsB;EACtB,kBAAkB;EAClB,4CAA4C;EAC5C,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,yBAAyB;AAC3B;AACA,yBAAyB,KAAK,yBAAyB,EAAE,EAAE","sourcesContent":["/* ============================================================\n   DonateForm — /donate body: gift widget + trust strip\n   ============================================================ */\n\n.dnform {\n  background: var(--c-cream);\n  border-top: 1px solid var(--line);\n}\n\n/* ── Two-column layout ── */\n.dnform__inner {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: clamp(3rem, 7vw, 8rem);\n  align-items: start;\n  padding-block: clamp(3rem, 6vw, 5.5rem);\n}\n\n/* ══════════════════════════════════════════════════════════════\n   LEFT — headline + copy + badge\n══════════════════════════════════════════════════════════════ */\n\n.dnform__left {\n  display: flex;\n  flex-direction: column;\n  gap: clamp(0.85rem, 1.5vw, 1.25rem);\n}\n\n.dnform__eyebrow {\n  color: var(--accent) !important;\n  letter-spacing: 0.24em;\n}\n\n.dnform__headline {\n  font-size: clamp(2.4rem, 5.5vw, 4.8rem);\n  color: var(--c-forest);\n  line-height: 0.9;\n  margin: 0;\n}\n\n.dnform__rule {\n  display: block;\n  width: clamp(2rem, 3.5vw, 3rem);\n  height: 3px;\n  background: var(--accent);\n  margin-block: 0.2rem;\n}\n\n.dnform__sub {\n  font-family: var(--font-body);\n  font-size: clamp(0.88rem, 1.1vw, 1rem);\n  color: var(--c-ink);\n  line-height: 1.7;\n  margin: 0;\n  max-width: 26rem;\n}\n\n/* 501c3 badge box */\n.dnform__badge {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.85rem;\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: 1rem 1.1rem;\n  margin-top: 0.5rem;\n  max-width: 26rem;\n}\n\n.dnform__badge-icon {\n  flex-shrink: 0;\n  width: 2.4rem;\n  height: 2.4rem;\n  color: var(--accent);\n}\n.dnform__badge-icon svg { width: 100%; height: 100%; }\n\n.dnform__badge-text {\n  font-family: var(--font-body);\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  line-height: 1.55;\n  margin: 0;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   RIGHT — donation widget\n══════════════════════════════════════════════════════════════ */\n\n.dnform__widget {\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: clamp(1.5rem, 3vw, 2.5rem);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  background: var(--c-cream);\n}\n\n/* Frequency toggle */\n.dnform__freq {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  border: 1px solid var(--line);\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n}\n\n.dnform__freq-btn {\n  background: transparent;\n  border: none;\n  padding: 0.75rem 1rem;\n  font-family: var(--font-body);\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: background var(--dur) var(--ease), color var(--dur) var(--ease);\n}\n\n.dnform__freq-btn--active {\n  background: var(--accent);\n  color: var(--on-accent);\n}\n\n/* Amount grid */\n.dnform__amounts {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 0.55rem;\n}\n\n.dnform__amt-btn {\n  border: 1px solid var(--line);\n  border-radius: var(--radius-sm);\n  background: transparent;\n  padding: 0.7rem 0.5rem;\n  font-family: var(--font-body);\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--c-ink);\n  cursor: pointer;\n  text-align: center;\n  transition: background var(--dur) var(--ease), border-color var(--dur) var(--ease), color var(--dur) var(--ease);\n}\n\n.dnform__amt-btn--active {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--on-accent);\n}\n\n.dnform__amt-btn:hover:not(.dnform__amt-btn--active) {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n/* Custom amount input */\n.dnform__amt-input {\n  -webkit-appearance: none;\n  appearance: none;\n  outline: none;\n  font-size: 0.78rem;\n  letter-spacing: 0.1em;\n}\n.dnform__amt-input::placeholder {\n  font-size: 0.68rem;\n  letter-spacing: 0.14em;\n  color: rgba(27,27,27,0.35);\n  font-weight: 700;\n}\n.dnform__amt-input::-webkit-outer-spin-button,\n.dnform__amt-input::-webkit-inner-spin-button { -webkit-appearance: none; }\n\n/* Dedicate checkbox */\n.dnform__dedicate {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  cursor: pointer;\n}\n\n.dnform__checkbox {\n  width: 1rem;\n  height: 1rem;\n  border: 1.5px solid var(--line);\n  border-radius: 2px;\n  cursor: pointer;\n  accent-color: var(--accent);\n  flex-shrink: 0;\n}\n\n.dnform__dedicate-label {\n  font-family: var(--font-body);\n  font-size: 0.78rem;\n  color: var(--text-muted);\n  line-height: 1.4;\n}\n\n/* Primary donate button */\n.dnform__donate-btn {\n  width: 100%;\n  background: var(--accent);\n  color: var(--on-accent);\n  border: none;\n  border-radius: 0;\n  padding: 1rem;\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: 0.72rem;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: background var(--dur) var(--ease);\n}\n.dnform__donate-btn:hover { background: var(--accent-hover); }\n.dnform__donate-btn:disabled { opacity: 0.4; cursor: not-allowed; }\n\n/* OR divider */\n.dnform__or {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-block: -0.1rem;\n}\n.dnform__or-line {\n  flex: 1;\n  height: 1px;\n  background: var(--line);\n}\n.dnform__or-text {\n  font-family: var(--font-body);\n  font-size: 0.65rem;\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  color: var(--text-muted);\n}\n\n/* Pay buttons */\n.dnform__pay-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  padding: 0.85rem 1rem;\n  border-radius: 2px;\n  font-family: var(--font-body);\n  font-size: 0.82rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: opacity var(--dur) var(--ease);\n}\n.dnform__pay-btn:hover { opacity: 0.85; }\n\n.dnform__pay-btn span {\n  font-size: 0.72rem;\n  font-weight: 500;\n  letter-spacing: 0.08em;\n}\n\n.dnform__pay-btn--gpay {\n  background: #fff;\n  border: 1px solid var(--line);\n  color: var(--c-ink);\n}\n\n.dnform__pay-btn--apay {\n  background: #1a1a1a;\n  border: none;\n  color: #fff;\n}\n\n.dnform__gpay-logo,\n.dnform__apay-logo {\n  height: 1.1rem;\n  width: auto;\n}\n\n/* Secure note */\n.dnform__secure {\n  font-family: var(--font-body);\n  font-size: 0.68rem;\n  color: var(--text-muted);\n  text-align: center;\n  margin: -0.25rem 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n}\n.dnform__secure svg { font-size: 0.65rem; }\n\n/* Success banner */\n.dnform__success {\n  padding: 1.5rem;\n  text-align: center;\n}\n.dnform__success p {\n  font-family: var(--font-serif);\n  font-style: italic;\n  font-size: 1.05rem;\n  color: var(--c-forest);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   YOU CAN TRUST US strip\n══════════════════════════════════════════════════════════════ */\n\n.dnform__trust {\n  background: var(--c-cream);\n  border-top: 1px solid var(--line);\n  padding-block: clamp(2rem, 4vw, 3.5rem);\n}\n\n.dnform__trust-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: clamp(1rem, 2.5vw, 2.5rem);\n  margin-bottom: clamp(1.75rem, 3vw, 2.75rem);\n}\n\n.dnform__trust-rule {\n  display: block;\n  flex: 1;\n  max-width: clamp(3rem, 8vw, 8rem);\n  height: 1px;\n  background: var(--line);\n}\n\n.dnform__trust-eyebrow {\n  /* u-eyebrow base */\n  margin: 0;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* 4-column trust grid */\n.dnform__trust-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0;\n}\n\n.dnform__trust-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.85rem;\n  padding-inline: clamp(0.75rem, 2vw, 1.75rem);\n  position: relative;\n}\n\n.dnform__trust-item:not(:last-child)::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: var(--line);\n}\n\n.dnform__trust-icon {\n  font-size: 1.25rem;\n  color: var(--accent);\n  flex-shrink: 0;\n  margin-top: 2px;\n  display: flex;\n}\n\n.dnform__trust-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.dnform__trust-label {\n  font-family: var(--font-body);\n  font-size: 0.6rem;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--c-ink);\n  margin: 0;\n}\n\n.dnform__trust-desc {\n  font-family: var(--font-body);\n  font-size: clamp(0.72rem, 0.9vw, 0.82rem);\n  color: var(--text-muted);\n  line-height: 1.55;\n  margin: 0;\n}\n\n/* Responsive */\n@media (max-width: 991.98px) {\n  .dnform__inner { grid-template-columns: 1fr; gap: 2.5rem; }\n  .dnform__trust-grid { grid-template-columns: repeat(2, 1fr); gap: 1.5rem 0; }\n  .dnform__trust-item:nth-child(2)::after,\n  .dnform__trust-item:nth-child(4)::after { display: none; }\n}\n\n@media (max-width: 575.98px) {\n  .dnform__amounts { grid-template-columns: repeat(3, 1fr); }\n  .dnform__trust-grid { grid-template-columns: 1fr; }\n  .dnform__trust-item::after { display: none; }\n}\n\n/* ═══════════════════════════════════════════════════════\n   Stripe Payment Element + new fields\n═══════════════════════════════════════════════════════ */\n\n/* ── Checkout wrapper ── */\n.dnform__checkout {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n/* Summary bar above Payment Element */\n.dnform__checkout-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  background: rgba(184,92,56,0.06);\n  border: 1px solid rgba(184,92,56,0.18);\n  border-radius: 9px;\n  padding: 0.85rem 1rem;\n  margin-bottom: 1.25rem;\n}\n.dnform__checkout-label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #9ca3af;\n  margin: 0 0 0.2rem;\n}\n.dnform__checkout-amount {\n  font-size: 1.4rem;\n  font-weight: 800;\n  color: #b85c38;\n  margin: 0;\n  line-height: 1;\n}\n.dnform__checkout-amount span {\n  font-size: 0.8rem;\n  font-weight: 600;\n  opacity: 0.7;\n  margin-left: 0.25rem;\n}\n.dnform__checkout-campaign {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: #1b1b1b;\n  margin: 0;\n}\n\n/* Payment Element container */\n.dnform__payment-element-wrap {\n  margin-bottom: 0;\n}\n\n/* Stripe error message */\n.dnform__stripe-error {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.4rem;\n  background: rgba(220,38,38,0.07);\n  border: 1px solid rgba(220,38,38,0.22);\n  border-radius: 7px;\n  padding: 0.65rem 0.85rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #dc2626;\n  margin-top: 0.85rem;\n}\n.dnform__stripe-error span { font-size: 0.75rem; flex-shrink: 0; }\n\n/* Stripe form wrapper */\n.dnform__stripe-form { display: flex; flex-direction: column; }\n\n/* Back link */\n.dnform__back-link {\n  background: none;\n  border: none;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #9ca3af;\n  cursor: pointer;\n  text-align: center;\n  margin-top: 0.75rem;\n  padding: 0.25rem;\n  transition: color 0.15s;\n}\n.dnform__back-link:hover { color: #6b6258; }\n.dnform__back-link:disabled { opacity: 0.4; cursor: wait; }\n\n/* ── Picker fields ── */\n.dnform__field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  margin-bottom: 0.85rem;\n}\n.dnform__field-label { font-size: 0.8rem; font-weight: 700; color: #1b1b1b; }\n.dnform__field-opt   { font-size: 0.72rem; font-weight: 400; color: #9ca3af; }\n.dnform__field-req   { color: #b85c38; }\n.dnform__field-hint  { font-size: 0.7rem; color: #9ca3af; margin: 0.15rem 0 0; }\n.dnform__field-error { font-size: 0.75rem; color: #dc2626; font-weight: 600; margin: 0.15rem 0 0; }\n\n.dnform__input {\n  padding: 0.65rem 0.85rem;\n  border: 1px solid #ddd5c8;\n  border-radius: 7px;\n  background: #fff;\n  font-size: 0.88rem;\n  color: #1b1b1b;\n  outline: none;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n.dnform__input:focus {\n  border-color: #b85c38;\n  box-shadow: 0 0 0 3px rgba(184,92,56,0.1);\n}\n.dnform__input--error {\n  border-color: #dc2626;\n  box-shadow: 0 0 0 3px rgba(220,38,38,0.08);\n}\n\n.dnform__select-wrap { position: relative; }\n.dnform__select {\n  appearance: none;\n  width: 100%;\n  padding: 0.65rem 2rem 0.65rem 0.85rem;\n  border: 1px solid #ddd5c8;\n  border-radius: 7px;\n  background: #fff;\n  font-size: 0.88rem;\n  color: #1b1b1b;\n  outline: none;\n  cursor: pointer;\n  transition: border-color 0.15s;\n}\n.dnform__select:focus  { border-color: #b85c38; }\n.dnform__select-chevron {\n  position: absolute;\n  right: 0.85rem;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: #9ca3af;\n  font-size: 0.75rem;\n}\n\n/* ── Methods strip (below CTA) ── */\n.dnform__methods-strip {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  font-size: 0.7rem;\n  color: #9ca3af;\n  margin-top: 0.75rem;\n  font-weight: 500;\n}\n\n/* ── Accepted payment logos (left column) ── */\n.dnform__accepted { margin-top: 1.75rem; }\n.dnform__accepted-label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #9ca3af;\n  margin: 0 0 0.6rem;\n}\n.dnform__accepted-logos {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  align-items: center;\n}\n.dnform__pm-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 26px;\n  padding: 0 0.6rem;\n  border-radius: 4px;\n  background: #f4efe6;\n  border: 1px solid #e8e3da;\n}\n.dnform__pm-chip svg { height: 14px; display: block; }\n.dnform__pm-chip--visa  { background: #fff; }\n.dnform__pm-chip--amex  { background: #2E77BC; }\n.dnform__pm-chip--gpay  { background: #fff; }\n.dnform__pm-chip--apay  { background: #000; }\n.dnform__pm-chip--link  { background: #00D66B; padding: 0 0.75rem; }\n\n/* ── Loading / disabled / success ── */\n.dnform__loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 220px;\n}\n\n.dnform__disabled {\n  text-align: center;\n  padding: 2.5rem 1rem;\n}\n.dnform__disabled-icon  { font-size: 2.5rem; margin-bottom: 0.85rem; }\n.dnform__disabled-title { font-family: var(--font-serif); font-size: 1.4rem; color: #384638; margin: 0 0 0.75rem; }\n.dnform__disabled-text  { font-size: 0.88rem; color: #6b6258; line-height: 1.6; margin: 0; }\n.dnform__disabled-text a { color: #b85c38; }\n\n.dnform__success-v2 { text-align: center; padding: 2rem 0.5rem; }\n.dnform__success-icon-lg { font-size: 3rem; margin-bottom: 0.75rem; }\n.dnform__success-title   { font-family: var(--font-serif); font-size: 1.6rem; color: #384638; margin: 0 0 0.35rem; }\n.dnform__success-amt     { font-size: 1.75rem; font-weight: 800; color: #b85c38; margin: 0 0 0.85rem; }\n.dnform__success-text    { font-size: 0.9rem; color: #1b1b1b; line-height: 1.6; margin: 0 0 0.5rem; }\n.dnform__success-sub     { font-size: 0.8rem; color: #6b6258; line-height: 1.55; margin: 0; }\n\n/* ── Spinner ── */\n.dnform__spinner {\n  display: inline-block;\n  width: 0.9rem;\n  height: 0.9rem;\n  border: 2px solid rgba(255,255,255,0.35);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: dnform-spin 0.65s linear infinite;\n  vertical-align: middle;\n}\n.dnform__spinner--lg {\n  width: 2rem;\n  height: 2rem;\n  border-color: rgba(184,92,56,0.2);\n  border-top-color: #b85c38;\n}\n@keyframes dnform-spin { to { transform: rotate(360deg); } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
